import React, { useEffect, useRef, useState } from "react";
import { Palette, Check } from "lucide-react";
import { THEME_LIST } from "../lib/themes";

export default function ThemeSelector({ themeId, onChange, compact = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function onDoc(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  const current = THEME_LIST.find((t) => t.id === themeId) || THEME_LIST[0];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className={
          "flex items-center gap-1.5 rounded-md border border-ide-border bg-ide-surface hover:bg-ide-panel text-ide-text transition-colors " +
          (compact ? "px-2 py-1 text-[11px]" : "px-2.5 py-1.5 text-xs")
        }
        title="Editor theme"
        data-testid="theme-selector-btn"
      >
        <Palette className={compact ? "h-3 w-3" : "h-3.5 w-3.5"} />
        {!compact && <span>{current.label}</span>}
      </button>

      {open && (
        <div
          className="absolute right-0 top-full mt-1 min-w-[180px] bg-ide-panel border border-ide-borderHi rounded-md shadow-glow z-50 overflow-hidden"
          data-testid="theme-selector-menu"
        >
          <div className="px-3 py-2 text-[10px] uppercase tracking-wider text-ide-mute border-b border-ide-border">
            Editor theme
          </div>
          {THEME_LIST.map((t) => (
            <button
              key={t.id}
              onClick={() => { onChange?.(t.id); setOpen(false); }}
              className={
                "w-full flex items-center gap-2 px-3 py-2 text-sm text-left transition-colors " +
                (t.id === themeId
                  ? "bg-ide-surface text-ide-accent"
                  : "text-ide-text hover:bg-ide-surface")
              }
              data-testid={`theme-option-${t.id}`}
            >
              <span className="flex-1">{t.label}</span>
              {t.id === themeId && <Check className="h-3.5 w-3.5 text-ide-accent" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
